export default __webpack_public_path__ + "static/media/microphone_AI.e4cd9c2c.svg";